import {Injectable} from '@angular/core';
import {AppConfigService} from './app-config.service';
import {LoggedUserService} from './logged-user.service';
import {HttpClient} from '@angular/common/http';
import {AbstractGeoDictService} from './abstract-geo-dict.service';
import {CityBaseDto, PostCodeBaseDto, ProvinceBaseDto} from '../model';

@Injectable()
export class GeoDictBaseService extends AbstractGeoDictService<CityBaseDto, PostCodeBaseDto, ProvinceBaseDto> {
  protected url = this.urlPrefix + 'geoBase';

  constructor(public http: HttpClient, appConfigService: AppConfigService, _loggedUserService: LoggedUserService) {
    super(http, appConfigService, _loggedUserService);
  }
}
